import { render, staticRenderFns } from "./exchangeRate.vue?vue&type=template&id=67e7838f&scoped=true&"
import script from "./exchangeRate.vue?vue&type=script&lang=js&"
export * from "./exchangeRate.vue?vue&type=script&lang=js&"
import style0 from "./exchangeRate.vue?vue&type=style&index=0&id=67e7838f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e7838f",
  null
  
)

export default component.exports